(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["mk-free-gift"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.mkFreeGiftInit) return;
    window.mkFreeGiftInit = true;

    var origFetch = window.fetch.bind(window);

    // Le cadeau choisi est injecté DANS la requête d'ajout au panier du produit :
    // un seul appel, les deux articles arrivent ensemble, le tiroir les affiche.
    window.fetch = function (input, init) {
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (url.indexOf('/cart/add') !== -1 && init && typeof init.body === 'string') {
          var chosen = document.querySelector('input[name="mk-gift-choice"]:checked');
          if (chosen && chosen.value) {
            var payload = JSON.parse(init.body);
            var vid = Number(chosen.value);
            if (payload && Array.isArray(payload.items)) {
              var already = payload.items.some(function (it) { return Number(it.id) === vid; });
              if (!already) payload.items.push({ id: vid, quantity: 1 });
              init.body = JSON.stringify(payload);
            } else if (payload && payload.id && Number(payload.id) !== vid) {
              init.body = JSON.stringify({
                items: [{ id: Number(payload.id), quantity: payload.quantity || 1 }, { id: vid, quantity: 1 }]
              });
            }
          }
        }
      } catch (e) {
        /* en cas d'imprévu, la requête d'origine part inchangée */
      }
      return origFetch(input, init);
    };
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["mk-gift-box"] && !Shopify.designMode) return;
  try {
    (function () {
    function initGift() {
      var gifts = document.querySelectorAll('[data-mk-gift]');
      if (!gifts.length) return;

      if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        Array.prototype.forEach.call(gifts, function (g) {
          g.classList.add('mk-gift--open');
        });
        return;
      }

      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('mk-gift--open');
              io.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.35 }
      );
      Array.prototype.forEach.call(gifts, function (g) {
        io.observe(g);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initGift);
    } else {
      initGift();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["mk-installments"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.mkInstallmentsInit) return;
    window.mkInstallmentsInit = true;

    document.addEventListener('variant:updated', function (event) {
      var html = event.detail && event.detail.data && event.detail.data.html;
      if (!html) return;
      document.querySelectorAll('[data-mk-installments]').forEach(function (el) {
        var fresh = html.querySelector('[data-mk-installments="' + el.getAttribute('data-mk-installments') + '"]');
        if (fresh && fresh.innerHTML !== el.innerHTML) el.innerHTML = fresh.innerHTML;
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["mk-order-bump"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.mkOrderBumpInit) return;
    window.mkOrderBumpInit = true;

    var origFetch = window.fetch.bind(window);

    /* L'option cochée est injectée dans la requête d'ajout au panier du
       produit principal : un seul appel, les deux articles arrivent ensemble. */
    window.fetch = function (input, init) {
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (url.indexOf('/cart/add') !== -1 && init && typeof init.body === 'string') {
          var chosen = document.querySelector('input[name="mk-bump-choice"]:checked');
          if (chosen && chosen.value) {
            var payload = JSON.parse(init.body);
            var vid = Number(chosen.value);
            if (payload && Array.isArray(payload.items)) {
              var already = payload.items.some(function (it) { return Number(it.id) === vid; });
              if (!already) payload.items.push({ id: vid, quantity: 1 });
              init.body = JSON.stringify(payload);
            } else if (payload && payload.id && Number(payload.id) !== vid) {
              init.body = JSON.stringify({
                items: [{ id: Number(payload.id), quantity: payload.quantity || 1 }, { id: vid, quantity: 1 }]
              });
            }
          }
        }
      } catch (e) {
        /* en cas d'imprévu, la requête d'origine part inchangée */
      }
      return origFetch(input, init);
    };
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["mk-promo-code"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.mkPromoCopyInit) return;
    window.mkPromoCopyInit = true;

    function copyText(text) {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        return navigator.clipboard.writeText(text).catch(function () {
          return legacyCopy(text);
        });
      }
      return legacyCopy(text);
    }

    function legacyCopy(text) {
      return new Promise(function (resolve, reject) {
        var ta = document.createElement('textarea');
        ta.value = text;
        ta.setAttribute('readonly', '');
        ta.style.position = 'fixed';
        ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.select();
        try {
          document.execCommand('copy') ? resolve() : reject();
        } catch (e) {
          reject(e);
        }
        document.body.removeChild(ta);
      });
    }

    /* Phase capture : le slider du bandeau stoppe la propagation en bubble */
    document.addEventListener('click', function (event) {
      var chip = event.target.closest('[data-mk-promo-code]');
      if (!chip) return;
      copyText(chip.getAttribute('data-mk-promo-code')).then(function () {
        var idle = chip.querySelector('[data-mk-promo-idle]');
        var done = chip.querySelector('[data-mk-promo-done]');
        if (!idle || !done) return;
        idle.hidden = true;
        done.hidden = false;
        clearTimeout(chip.mkPromoTimer);
        chip.mkPromoTimer = setTimeout(function () {
          idle.hidden = false;
          done.hidden = true;
        }, 2000);
      });
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["mk-set-value"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.mkSetValueInit) return;
    window.mkSetValueInit = true;

    document.addEventListener('variant:updated', function (event) {
      var html = event.detail && event.detail.data && event.detail.data.html;
      if (!html) return;
      document.querySelectorAll('[data-mk-setvalue]').forEach(function (el) {
        var fresh = html.querySelector('[data-mk-setvalue="' + el.getAttribute('data-mk-setvalue') + '"]');
        if (fresh && fresh.innerHTML !== el.innerHTML) el.innerHTML = fresh.innerHTML;
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["mk-why-choose"] && !Shopify.designMode) return;
  try {
    (function () {
    function initWhyLines() {
      var lines = document.querySelectorAll('.mk-why__line');
      if (!lines.length) return;

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        Array.prototype.forEach.call(lines, function (l) {
          l.firstElementChild.style.height = '100%';
        });
        return;
      }

      function update() {
        var trigger = window.innerHeight * 0.72;
        Array.prototype.forEach.call(lines, function (l) {
          var r = l.getBoundingClientRect();
          if (!r.height) return;
          var p = (trigger - r.top) / r.height;
          p = Math.max(0, Math.min(1, p));
          l.firstElementChild.style.height = p * 100 + '%';
        });
      }

      var ticking = false;
      window.addEventListener(
        'scroll',
        function () {
          if (!ticking) {
            ticking = true;
            requestAnimationFrame(function () {
              update();
              ticking = false;
            });
          }
        },
        { passive: true }
      );
      window.addEventListener('resize', update);
      window.addEventListener('load', update);
      update();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initWhyLines);
    } else {
      initWhyLines();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
